/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import TestPage from "./views/TestPage.vue";
// import Home from "./views/Home.vue";
import CatePage from "./views/CatePage.vue";
import Content from "./views/Content.vue";
import Profile from "./views/Profile.vue";
import Setting from "./views/Setting.vue";
import Management from "./views/Management.vue";
import Reported from "./views/Reported.vue"
import GroupProfile from "./views/GroupProfile.vue"
import PackContent from "./views/PackContent.vue"
import MindMapHome from "./views/MindMapHome.vue"
import MindMap from "./components/MindMap.vue"
import MindCollect from "./views/MindCollect.vue"
import HTwbMind from "./HTwbMind/HTwbMind.vue"
import HTpvpGameSetting from "./HTwbActKit/HTpvpGameSetting.vue"
import HTpvpGamePlay from "./HTwbActKit/HTpvpGamePlay.vue"
import HTMoleGameSetting from "./HTwbActKit/HTMoleGameSetting.vue"
import HTMoleGamePlay from "./HTwbActKit/HTMoleGamePlay.vue"
import HTpvpTFGamePlay from "./HTwbActKit/HTpvpTFGamePlay.vue"
import HTpvpTFGameSetting from "./HTwbActKit/HTpvpTFGameSetting.vue"
import HTwbActKitHome from "./HTwbActKit/HTwbActKitHome.vue"
import HTPickGameSetting from "./HTwbActKit/HTPickGameSetting.vue"
import HTPickGamePlay from "./HTwbActKit/HTPickGamePlay.vue"
import HTSnakeGameSetting from "./HTwbActKit/HTSnakeGameSetting.vue"
import HTSnakeGamePlay from "./HTwbActKit/HTSnakeGamePlay.vue"
import HTPunchBoardSetting from "./HTwbActKit/HTPunchBoardSetting.vue"
import HTPunchBoardPlay from "./HTwbActKit/HTPunchBoardPlay.vue"
import HTMazeGameSetting from "./HTwbActKit/HTMazeGameSetting.vue"
import HTMazeGamePlay from "./HTwbActKit/HTMazeGamePlay.vue"
import HTAIGamePlay from "./HTwbActKit/HTAIGamePlay.vue"
import PublicAIGamePlay from "./HTwbActKit/PublicAIGamePlay.vue"
import MindCollectNormal from "./views/MindCollectNormal.vue"
import HTwbCardHome from "./HTwbCard/HTwbCardHome.vue"
import HTwbCardCollect from "./HTwbCard/HTwbCardCollect.vue"
import AIPromptHome from "./HTwbAIprompt/AIPromptHome.vue"
import AdminLogin from "./HTwbAIprompt/AdminLogin.vue"
import AdminUpload from "./HTwbAIprompt/AdminUpload.vue"
import AIPromptCollect from "./HTwbAIprompt/AIPromptCollect.vue"
import GameActManager from "./GameActManager/GameActManager.vue"

const routes = [
  // {
  //   path: "/testPage",
  //   name: "TestPage",
  //   component: TestPage,
  //   meta: { requiresAuth: false },
  // },
  {
    path: "/",
    redirect: "/mindmaphome", //2025目前對外只有mindmaphome，其他資源網內容先隱藏
  },
  {
    path: "/htwb-actkit-home",
    name: "HTwbActKitHome",
    component: HTwbActKitHome,
    meta: { requiresAuth: false },
  },
  {
    path: "/mindcollect",
    name: "MindCollect",
    component: MindCollect,
    meta: { requiresAuth: false },
  },
  {
    path: "/htwbmind",
    name: "HTwbMind",
    component: HTwbMind,
    meta: { requiresAuth: false },
  },
  {
    path: "/playground",
    name: "Playground",
    component: HTwbMind,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-pvpgame-play",
    name: "HTpvpGamePlay",
    component: HTpvpGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-pvpgame-setting",
    name: "HTpvpGameSetting",
    component: HTpvpGameSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-molegame-setting",
    name: "HTMoleGameSetting",
    component: HTMoleGameSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-molegame-play",
    name: "HTMoleGamePlay",
    component: HTMoleGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-pvp-tfgame-play",
    name: "HTpvpTFGamePlay",
    component: HTpvpTFGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-pvp-tfgame-setting",
    name: "HTpvpTFGameSetting",
    component: HTpvpTFGameSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-snakegame-setting",
    name: "HTSnakeGameSetting",
    component: HTSnakeGameSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-snakegame-play",
    name: "HTSnakeGamePlay",
    component: HTSnakeGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-pickgame-setting",
    name: "HTPickGameSetting",
    component: HTPickGameSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-pickgame-play",
    name: "HTPickGamePlay",
    component: HTPickGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-punchboard-setting",
    name: "HTPunchBoardSetting",
    component: HTPunchBoardSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-punchboard-play",
    name: "HTPunchBoardPlay",
    component: HTPunchBoardPlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-mazegame-setting",
    name: "HTMazeGameSetting",
    component: HTMazeGameSetting,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-mazegame-play",
    name: "HTMazeGamePlay",
    component: HTMazeGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/ht-aigame-play",
    name: "HTAIGamePlay",
    component: HTAIGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/public-aigame-play",
    name: "PublicAIGamePlay",
    component: PublicAIGamePlay,
    meta: { requiresAuth: false },
  },
  {
    path: "/mindcollect_normal",
    name: "MindCollectNormal",
    component: MindCollectNormal,
    meta: { requiresAuth: false },
  },
  {
    path: "/cardcollect/:id",
    name: "HTwbCardCollect",
    component: HTwbCardCollect,
    meta: { requiresAuth: false },
  },
  {
    path: "/aiprompt-collect",
    name: "AIPromptCollect",
    component: AIPromptCollect,
    meta: { requiresAuth: false },
  },
  // {
  //   path: "/:type",
  //   name: "CatePage",
  //   component: CatePage,
  //   meta: { requiresAuth: false },
  // },
  // {
  //   path: "/content/:type/:id",
  //   name: "Content",
  //   component: Content,
  //   meta: { requiresAuth: false },
  // },
  // {
  //   path: "/profile/:id",
  //   name: "Profile",
  //   component: Profile,
  //   meta: { requiresAuth: false },
  // },
  // {
  //   path: "/group/:id",
  //   name: "GroupProfile",
  //   component: GroupProfile,
  //   meta: { requiresAuth: false },
  // },
  // {
  //   path: "/pack/:id",
  //   name: "PackContent",
  //   component: PackContent,
  //   meta: { requiresAuth: false },
  // },
  // {
  //   path: "/setting",
  //   name: "Setting",
  //   component: Setting,
  //   meta: { requiresAuth: true },
  // },
  // {
  //   path: "/management",
  //   name: "Management",
  //   component: Management,
  //   meta: { requiresAuth: true },
  // },
  // {
  //   path:"/reported",
  //   name:"Reported",
  //   component:Reported,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/mindmaphome",
    name: "MindMapHome",
    component: MindMapHome,
    meta: { requiresAuth: false },
  },
  {
    path: "/mindmapclone",
    name: "MindMap",
    component: MindMap,
    meta: { requiresAuth: false },
  },
  // 使用通配符來處理不符合規則的路由
  {
    path: "/:pathMatch(.*)*",
    redirect: "/mindmaphome",
  },
  //HTwbCard區塊
  {
    path: "/htwb-card-home",
    name: "HTwbCardHome",
    component: HTwbCardHome,
    meta: { requiresAuth: false },
  },
  //AIPrompt區塊
  {
    path: "/ai-prompt-home",
    name: "AIPromptHome",
    component: AIPromptHome,
    meta: { requiresAuth: false },
  },
  {
    path: "/admin-login",
    name: "AdminLogin",
    component: AdminLogin,
    meta: { requiresAuth: false },
  },
  {
    path: "/admin-upload",
    name: "AdminUpload",
    component: AdminUpload,
    meta: { requiresAuth: false },
  },
  //遊戲活動管理區塊
  {
    path: "/game-act-manager",
    name: "GameActManager",
    component: GameActManager,
    meta: { requiresAuth: false },
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
